import { render } from "./StackedColumnChartComponent.vue?vue&type=template&id=3524c31a"
import script from "./StackedColumnChartComponent.vue?vue&type=script&lang=js"
export * from "./StackedColumnChartComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__